import { render } from "./jsCamera.vue?vue&type=template&id=c08af8a2&scoped=true"
import script from "./jsCamera.vue?vue&type=script&lang=js"
export * from "./jsCamera.vue?vue&type=script&lang=js"

import "./jsCamera.vue?vue&type=style&index=0&id=c08af8a2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08af8a2"]])

export default __exports__